export const defaultSelectedSubline = () => {
    return {
        subline_code: '',
        subline_description: '',
        short_description: '',
        lock_buy: 0,
        block_sale: 0,
        margin_cost: '',
        calculates_sale_price: 0,
        inventories_account: '',
        account_cost: '',
        sales_account: '',
        devol_sales_account: '',
        margin_price_vta: null,
        gift_allowed: false,
        apply: null,
        purchase_account: '',
        purchase_inventories_account: '',
        purchase_account_cost: '',
        devol_purchase_account: '',
        inventorie_account: null,
        cost_account: null,
        sale_account: null,
        devol_sale_account: null,
        purchase_inventorie_account: null,
        purchase_cost_account: null,
        purchase_account_entry: null,
        devol_purchase_entry: null,
        bridge_account_inventories: '',
        bridge_inventorie_account: null,
    }
}

export default {
    accountsInventory:[],
    paramsAccountInventory: {
        level:"0",
        paginate: true,
        page: 1,
        perPage: 1000,
        filter: "",
        sortBy: "code",
        sort: "ASC"
    },
    accountsCost:[],
    paramsAccountCost: {
        level:"0",
        paginate: true,
        page: 1,
        perPage: 1000,
        filter: "",
        sortBy: "code",
        sort: "ASC"
    },
    accountsSales:[],
    paramsAccountSales: {
        level:"0",
        paginate: true,
        page: 1,
        perPage: 1000,
        filter: "",
        sortBy: "code",
        sort: "ASC"
    },
    sublines: {
        data: []
    },
    sublinesList: [],
    selectedSubline: defaultSelectedSubline(),
    sublineTemplateAccounts: [],
    sublineModels: [],
    error: false,
    errorMessage: '',
    actionSubline: 'create',
    getContactEdit: true,

}


// WEBPACK FOOTER //
// ./src/modules/sublines/state.js